import type { MmaSessionFragmentFragment } from '../graphql/mma/generated/graphql';

export const useMmaBaseUser = () => {
  const user = useState<MmaSessionFragmentFragment>('mma-base-user');
  const setUser = (newUser: MmaSessionFragmentFragment) => { user.value = newUser; };
  const name = computed(() => user.value.preferred_name ?? user.value.first_name);
  const userOrUndefined = computed(() => {
    if (user.value.__typename === 'User') {
      return user.value;
    }
    return undefined;
  });
  const isImpersonating = computed(() => user.value?.sessionImpersonation ?? false);

  return {
    user,
    setUser,
    name,
    userOrUndefined,
    isImpersonating,
  };
};
